export default "__VITE_ASSET__C0cE89HA__"